import {  decode  as parseJwtToken} from 'jsonwebtoken'
import { unpackRules } from '@casl/ability/extra'

export const setLogin = (state, data) => {
  state.login = data;
};
export const setRole = (state, data) => {
  state.role = data;
};
export const setPermissions = (state, data) => {
  state.permissions = data;
};
export const setUserGuid = (state, data) => {
  state.userGuid = data;
};
export const setToken = (state, data) => {
  state.token = data;
};
export const setExpiredAt = (state, data) => {
  state.tokenExpire = data;
};
export const setAuthenticated = (state, data) => {
  state.authenticated = data;
};
export const clearLoading = (state, data) => {
  state.requests = 0;
  state.loading = !!state.requests;
};
export const setLoading = (state, data) => {
  if (data) state.requests++;
  else if(state.requests>0)  state.requests--;
  state.loading = !!state.requests;
};

export const setError = (state, data) => {
  state.error = data;
};

export const setOnlineStaff = (state, data) =>{
  state.onlineStaff = data;
}
export const setTransactionsQueue = (state, data) =>{
  state.transactionsQueue = data;
}

export const setAbilities = (state, data) =>{
  if(data){
    let jwt = parseJwtToken(data);
    state.abilities = unpackRules(jwt.rules);
  } else {
    state.abilities = state.degaultRules;
  }

};



// WEBPACK FOOTER //
// ./src/store/mutations.js